// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"328":"vendor.mapbox","336":"vendor.xdatepickers"}[chunkId] || chunkId) + ".js";
};